import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/29cb0df1/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const InlineNotification = makeShortcode("InlineNotification");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const ArtDirection = makeShortcode("ArtDirection");
const Caption = makeShortcode("Caption");
const Aside = makeShortcode("Aside");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`The elements constructing each chart are designed to work in harmony. Each piece plays an important role in data communication.`}</p>
    </PageDescription>
    <InlineNotification mdxType="InlineNotification">
      <p><strong parentName="p">{`Note:`}</strong>{` This guidance is a work in progress. To see our roadmap, make feature requests, or contribute, please go to carbon-charts `}<a parentName="p" {...{
          "href": "https://github.com/carbon-design-system/carbon-charts"
        }}>{`GitHub repository`}</a>{`.`}</p>
    </InlineNotification>
    <AnchorLinks mdxType="AnchorLinks">
      <AnchorLink mdxType="AnchorLink">Rectangular charts</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Circular charts</AnchorLink>
    </AnchorLinks>
    <h2>{`Rectangular charts`}</h2>
    <p>{`Most data visualizations are rectangular charts, with two dimensions represented on a vertical and a horizontal axis. Rectangular charts are typically constructed with a set of common elements including a legend, axis titles, and navigation tools like a zoom bar and tooltip.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} colMd={8} colSm={4} mdxType="Column">
        <ArtDirection mdxType="ArtDirection">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "684px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAADJklEQVQ4y6VU247bNhD1/39Ci761fSgQtD/QPjQBmkvbeNd21vHKa3tlWZZF3SmKFEWeDinv2kmQh7Y0BsOLfDhz5gwn1lrYwcB5Y8yzfb7+/AzOaFhv9DvvT/AfhwdyoBQM7GV/MjQdsp/+gMob3Lz+E7PXf2F9e4eH2RLzt+9xP134dXD7AQtar2htHIgb2kCzBkPGkb14A120mJhOgb8JoMnvggc8BhucwgPY/oh4G158RH639+ZpcoDGYqg72FahnW5hhLpK2X2hR8+OJ8hejUEMA/3PgjEGWXECoc2OPhTOej+3UkPn3NdiMhJMVKgePGLQaY0ppR4EAaIowmazQRzHuJneYH+3hkxKtHEOcSz8vHNG8+TbXyn9egR8qnIvFZTowFKGoihQliU4595YmqKpavR03vGWTIy+5dB9f1WUSuD03W/oCw5ZNOCPJ6i6/Wp11XApqkuuqz89nxjZo7uLIFiJ3ewjUFEExJXjzZ5t1N+ovaaz0Np4snluwHYGojJUHDFy6Cbsh1cQSYFwtgIaSrvtLoDmU0B5zm5QBHhysRqorEHyzZlDF6FcxT6qw+YRkvTY1vW58Pa5F57GLhV4CCOkMVC2BOYvoguVHjvFcci+f4nuVIKFMfqSCvDYoCvp7g6QwiLPBxxyiahUmB84FssUUWIQNz2WxxZ5Zy4cPt3tqrtfbbyumkygqA3CeMByO2A6V/j79wC7+RLrmwBNmLrwMFAQ29slij1D/vNbaNobdUhDtgLxJvRi3Z1qRC0B68Fz1NkB7xc7bGcLzKf3CKh4a2rNZBth++EedZqDv1tj4PKswzOoI50fM5RJRl1RQzUt2qJGnVckj5aq2SBPCzR+zcmXKFP6lrK7pGzHp8e3GRUop951VsYMivgVrKJ1AnDqV1JCFaeo6ULXeiKrUByoTZ1uLf7d8+Wks189YND6nIz98ilzEWqKIv/xJfJ1iXe/hKjoYagPKYo4w4tphZQILynCMjqhov2SzHhu8Sx8XFFGOtTUKXvipEe8qiGJN0V9KnmHj4mEIOFL4svvN8KbE/s14FN0/+/Fvkr5evwDdXwEqVDgJe8AAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Color in UI",
              "title": "Color in UI",
              "src": "/static/335fc5fafcabd9d832fb45429c62a7f4/ed00d/chart-anatomy-1sm.png",
              "srcSet": ["/static/335fc5fafcabd9d832fb45429c62a7f4/7fc1e/chart-anatomy-1sm.png 288w", "/static/335fc5fafcabd9d832fb45429c62a7f4/a5df1/chart-anatomy-1sm.png 576w", "/static/335fc5fafcabd9d832fb45429c62a7f4/ed00d/chart-anatomy-1sm.png 684w"],
              "sizes": "(max-width: 684px) 100vw, 684px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "59.91847826086957%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAAB30lEQVQoz4VT2Y7bMAzM/39XURTbvrXAdo9kczZ25Ni6b2lK29k2yaKoAZqSQFLDGWqBWvG/r1LMu+Hd/+NbjD/zdQm+a7F+XuKw2mD7skKz3mPztIRV+rb4xXtpoNmAKAyqDbA/D6gxzwUzN4jWw2kDNyi4XqJvGOQg4KyF9x4hBGghUX1CDRmJcjwTyINB0R7q4RUlpLngdQtRWiRh0WwPYF2HjowxhhM74bDeIdCFfpAIXFMsFaV9VA728Qqh+vwM2/QwjCOFOLVVSkXOefLzvkwXGpUJeUQgpMGlOcYT+m+rvwj1lxeI1S+oY4dCAbdsTS1MLvmCoXNwVCxHwOpCHBdEOq8xTZ3OCD89QW5byLaH15GCK7TJEDpBugIeClpCxc4JjQp4/LEFo/Z9LzDsW9izgP2+nRGODY1EGy5JNYEj82jOYbKWTPAATp73Ablm+FyxPw447Q542zR4XTcQxGVuBWouVPDSzuh1N4CTZeeRDCmvFKqLUMStJSHGtSZUQRlSr0Bzmghlp0I3c5hJ9vEwUkIhURKNRZ4skRrEldSUaKaEkvJkBJc88TaurwZ/FuXhBf6k0CwFjYHAW6PRMQnbcxhCho8yfVzX2S/un9EfClBvnty94X59mYbfiQulKsI3+kIAAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Color in UI",
              "title": "Color in UI",
              "src": "/static/b657388b19d90f466b6613c0104e5b0c/3cbba/chart-anatomy-1.png",
              "srcSet": ["/static/b657388b19d90f466b6613c0104e5b0c/7fc1e/chart-anatomy-1.png 288w", "/static/b657388b19d90f466b6613c0104e5b0c/a5df1/chart-anatomy-1.png 576w", "/static/b657388b19d90f466b6613c0104e5b0c/3cbba/chart-anatomy-1.png 1152w", "/static/b657388b19d90f466b6613c0104e5b0c/392b1/chart-anatomy-1.png 1472w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "59.91847826086957%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAAB30lEQVQoz4VT2Y7bMAzM/39XURTbvrXAdo9kczZ25Ni6b2lK29k2yaKoAZqSQFLDGWqBWvG/r1LMu+Hd/+NbjD/zdQm+a7F+XuKw2mD7skKz3mPztIRV+rb4xXtpoNmAKAyqDbA/D6gxzwUzN4jWw2kDNyi4XqJvGOQg4KyF9x4hBGghUX1CDRmJcjwTyINB0R7q4RUlpLngdQtRWiRh0WwPYF2HjowxhhM74bDeIdCFfpAIXFMsFaV9VA728Qqh+vwM2/QwjCOFOLVVSkXOefLzvkwXGpUJeUQgpMGlOcYT+m+rvwj1lxeI1S+oY4dCAbdsTS1MLvmCoXNwVCxHwOpCHBdEOq8xTZ3OCD89QW5byLaH15GCK7TJEDpBugIeClpCxc4JjQp4/LEFo/Z9LzDsW9izgP2+nRGODY1EGy5JNYEj82jOYbKWTPAATp73Ablm+FyxPw447Q542zR4XTcQxGVuBWouVPDSzuh1N4CTZeeRDCmvFKqLUMStJSHGtSZUQRlSr0Bzmghlp0I3c5hJ9vEwUkIhURKNRZ4skRrEldSUaKaEkvJkBJc88TaurwZ/FuXhBf6k0CwFjYHAW6PRMQnbcxhCho8yfVzX2S/un9EfClBvnty94X59mYbfiQulKsI3+kIAAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Color in UI",
              "title": "Color in UI",
              "src": "/static/b657388b19d90f466b6613c0104e5b0c/3cbba/chart-anatomy-1.png",
              "srcSet": ["/static/b657388b19d90f466b6613c0104e5b0c/7fc1e/chart-anatomy-1.png 288w", "/static/b657388b19d90f466b6613c0104e5b0c/a5df1/chart-anatomy-1.png 576w", "/static/b657388b19d90f466b6613c0104e5b0c/3cbba/chart-anatomy-1.png 1152w", "/static/b657388b19d90f466b6613c0104e5b0c/392b1/chart-anatomy-1.png 1472w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArtDirection>
        <Caption mdxType="Caption"></Caption>
      </Column>
      <Column colLg={2} colMd={2} colSm={2} offsetLg={1} mdxType="Column">
  <Aside mdxType="Aside">
    1. Chart title<br />
    2. Legends<br />
    3. Axes<br />
    4. Ticks<br />
    5. Axis title<br />
    6. Toolbar<br />
    7. Zoom bar<br />
    8. Graph frame<br />
    9. Tooltip<br />
  </Aside>
      </Column>
    </Row>
    <h4>{`Chart title`}</h4>
    <p>{`The title of a visualization should be concise and descriptive and should reflect the insight the data reveals.`}</p>
    <h4>{`Legend`}</h4>
    <p>{`Many charts will use different visual properties such as colors, textures, and shapes to represent different categories or dimensions of data. A legend tells you what these associations mean and helps you to determine the chart’s meaning. `}<a parentName="p" {...{
        "href": "../data-visualization/legends"
      }}>{`Read more on legend usage.`}</a></p>
    <h4>{`Axes`}</h4>
    <p>{`The X-axis is horizontal and the Y-axis is vertical. Axes should be accessible against their background with a 3:1 contrast ratio. `}<a parentName="p" {...{
        "href": "../data-visualization/axis-and-labels"
      }}>{`Read more on axes usage.`}</a></p>
    <h4>{`Tooltip`}</h4>
    <p>{`A tooltip is a message that appears when a cursor is positioned over an element, such as a data point, icon button, or truncated text. By default, tooltips show on hover to reveal more detailed information or context for specific chart elements. A tooltip should repeat the corresponding values of the data point on both axes and any other relevant details.`}</p>
    <h4>{`Graph frame`}</h4>
    <p>{`The graph frame is the area where data will be visualized with graphics or numbers. Gridlines help a viewer estimate the values of a data point but are not required. Use gridlines sparingly, as too much visual noise makes the graph frame busy and negatively impacts the user’s ability to interpret the data.`}</p>
    <h2>{`Circular charts`}</h2>
    <p>{`Circular charts are primarily pie and donut charts. Other circular layout charts include radar and solar charts.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} colMd={8} colSm={4} mdxType="Column">
        <ArtDirection mdxType="ArtDirection">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "684px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAADwklEQVQ4y42Uy4scVRTGa2HcieDGP0DduNGFKzcKuhFFhBmiG10YgyKCQUEQggqKUSISTFRCsokZZZwwGBKMY2JiyGTGnvf71dM9ycz0u3uqq+vd9fp5qma6Z1od8FKnbtWtW9+95/u+c5UoiojCEOJeIpTndux9j8Lke9xa/X81pfWw/5TO1gaL+72xM6YEuk3l/C0wm2ym15gY/IvMzCJL4zOsza+wODEjMUtmPk0YRDv/R/uGEroe5vRdJCdqpQrZpTSljTxrK5mk1wpl7EqNuppv7zKM9s+qM+X4JnTi7f4xfecuvUOjLN4IKc8H8s2TOR6hKb3tEZkukevj13QiP0BpiZJAyIRaNgdVndTUAo998CHKSy9y4JU3+OwZnU8fDzn3epPSuAOOTViTKDUEzKB85noCqrRyj1tgNYVLnyvDoygvH+SBN9/i28tXmJxLU5y0mehpcuI5n8+fDNi47YIrgHU34SBqidLmJb41Q2q5KvcdPswj772PWtgCX8YtSdWWXUU21obD910+J1/wcfMyJqJGXrgLGAUhft3E8/0E+FjfLyhdXUzMrcgCckk6gWoRqjZBVQACh1zK5RNJf/Scg1HJ4QqPLQkUX7MonhzA00zhJeTpj47y8LvvJLtyCipLlwfJXZ9k/uJNpvr/oJlXQXM43e1x4YgAGQah4xOYDvHmtjkMwu285cNTJy7SfWZAuPQIhPDVn2+w/OM1Vn66RrbvJl62AhWNC28b9LxmQU1LRCl9dxVPxFT2ukXyprtf54kfNGjYIIRrU1k2h2YpjixiL4gDDJdAMI8dnKf3aCHZROSHuz5sqewnqEL2bRXlyzyjq0YihKeL50oG+nIePV3Ezm5iLBS5+kWazIAURN2SdF2smXVCuyk73KnFZA2pmkbZ4qHTJR49W6ZYkJRcMW4mT+XPMZrjC9y5NM1MzxyZ3yYxZ1fxc3URzWSrfyQRV6HDh+J+w2EkY3H/N2UePFXi+K06g0sNhpYMPh7a4tARg1PP+mymYsuI+nWnowbbosRjUSxE4v4qE4tVnu+tcu9XBe45XuBAHF8XePV8ja1p4de2iMRKqLEPg93DofP4ksSlDG0xK003oWJD9fh9zeXXrEu25rdnRq6Y3ZFaFlFalZIABpJirS+VrLiealJY0LDrKppYw1M1UmsmZbEPDZVIa1DIl7k0PIarGdsg7YNleyEldJrow+mYQaqZAHXdxBWzGqoUvW4wJ+W1UTYw5d2q62zV6owtixixkfecjfyzlqP/e2R3Ht//ev8b1sTFiaj/auEAAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Color in UI",
              "title": "Color in UI",
              "src": "/static/c8ec7b7d5638f29512056426e2dae052/ed00d/chart-anatomy-2sm.png",
              "srcSet": ["/static/c8ec7b7d5638f29512056426e2dae052/7fc1e/chart-anatomy-2sm.png 288w", "/static/c8ec7b7d5638f29512056426e2dae052/a5df1/chart-anatomy-2sm.png 576w", "/static/c8ec7b7d5638f29512056426e2dae052/ed00d/chart-anatomy-2sm.png 684w"],
              "sizes": "(max-width: 684px) 100vw, 684px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "59.375%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAABwUlEQVQoz4WTz27TQBDG+1JcK3FFPACniofgwAm1tEUCceJOc6lAnOCEBJXKJYWEIiooqA5J5PRPmqZu4ti7tpNdr39s3CgKpm1GGs2sNPN9M/vtLjCxLMuY5lxteY31rOCz/Quzhyw1iK8NSBTn7Q6uU6ftHuG1jhGDi7zGmGuIJvYvoI3KC8ACx2GE8gVGxOz+cqjt+TAc16WYYZqT6yDK438TFlnykpGh0+pw99lzbq+uU3rYZfO+4aSaQBRhIkX4uYZJRjcDZia7vEOVcefJUx69emPBxyya5rZiY0kTulE+6fyV7fhB2cmn+/GnyeLyMoQaf69Ju/wb5Bkf1lIqL0NbnZC4F2QqvUEUG7UVZGyVRo97rw9gIGm8r1J7uwOex/aLPpWNXj6h3D/GjPSclSfnWGgWN/vsNqW9M+uOy3C/RbXk0P3Wtngp4rtrBVLzRcmX0IqPP31ulbo83uqxsnXKg/VzGu/sKwiDXGnty6tVnl05lUMrjEFJCxtKDk4kq+WQlR3Bp7oVQ1qFEj0FmiuK+FInixP6h4rAC0mFYDCILYhE9DyOTs+mINf+lCLLbENqn5G2rtLLvAhEoe8v55CUzy/9FGMAAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Color in UI",
              "title": "Color in UI",
              "src": "/static/57b79fa6ae592e6fe6bfc32edcf69a2f/3cbba/chart-anatomy-2.png",
              "srcSet": ["/static/57b79fa6ae592e6fe6bfc32edcf69a2f/7fc1e/chart-anatomy-2.png 288w", "/static/57b79fa6ae592e6fe6bfc32edcf69a2f/a5df1/chart-anatomy-2.png 576w", "/static/57b79fa6ae592e6fe6bfc32edcf69a2f/3cbba/chart-anatomy-2.png 1152w", "/static/57b79fa6ae592e6fe6bfc32edcf69a2f/392b1/chart-anatomy-2.png 1472w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "59.375%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAABwUlEQVQoz4WTz27TQBDG+1JcK3FFPACniofgwAm1tEUCceJOc6lAnOCEBJXKJYWEIiooqA5J5PRPmqZu4ti7tpNdr39s3CgKpm1GGs2sNPN9M/vtLjCxLMuY5lxteY31rOCz/Quzhyw1iK8NSBTn7Q6uU6ftHuG1jhGDi7zGmGuIJvYvoI3KC8ACx2GE8gVGxOz+cqjt+TAc16WYYZqT6yDK438TFlnykpGh0+pw99lzbq+uU3rYZfO+4aSaQBRhIkX4uYZJRjcDZia7vEOVcefJUx69emPBxyya5rZiY0kTulE+6fyV7fhB2cmn+/GnyeLyMoQaf69Ju/wb5Bkf1lIqL0NbnZC4F2QqvUEUG7UVZGyVRo97rw9gIGm8r1J7uwOex/aLPpWNXj6h3D/GjPSclSfnWGgWN/vsNqW9M+uOy3C/RbXk0P3Wtngp4rtrBVLzRcmX0IqPP31ulbo83uqxsnXKg/VzGu/sKwiDXGnty6tVnl05lUMrjEFJCxtKDk4kq+WQlR3Bp7oVQ1qFEj0FmiuK+FInixP6h4rAC0mFYDCILYhE9DyOTs+mINf+lCLLbENqn5G2rtLLvAhEoe8v55CUzy/9FGMAAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Color in UI",
              "title": "Color in UI",
              "src": "/static/57b79fa6ae592e6fe6bfc32edcf69a2f/3cbba/chart-anatomy-2.png",
              "srcSet": ["/static/57b79fa6ae592e6fe6bfc32edcf69a2f/7fc1e/chart-anatomy-2.png 288w", "/static/57b79fa6ae592e6fe6bfc32edcf69a2f/a5df1/chart-anatomy-2.png 576w", "/static/57b79fa6ae592e6fe6bfc32edcf69a2f/3cbba/chart-anatomy-2.png 1152w", "/static/57b79fa6ae592e6fe6bfc32edcf69a2f/392b1/chart-anatomy-2.png 1472w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArtDirection>
        <Caption mdxType="Caption"></Caption>
      </Column>
      <Column colLg={2} colMd={2} colSm={2} offsetLg={1} mdxType="Column">
  <Aside mdxType="Aside">
    1. Chart title<br />
    2. Legends<br />
    3. Label<br />
    4. Graph frame<br />
    5. Big number<br />
    6. Tooltip<br />
  </Aside>
      </Column>
    </Row>
    <h4>{`Label`}</h4>
    <p>{`A label offers the percentage value of the whole for an individual category.`}</p>
    <h4>{`Big number or KPI`}</h4>
    <p>{`A key performance indicator (KPI) consists of a number with a single word description. Examples include “15,250 browsers”, “\$1.3M revenue”, or “Total 450”. A big number inside the donut chart may be used to display a total sum or the individual count of a slice upon interaction. This element can also be used independently on a dashboard (though please note this component is still a WIP and not available outside the donut chart).`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      